import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { TreasuryComposite } from "@/domains/treasury/components/treasury-composite"
import { createBreadcrumbItem } from "@/domains/diagnostics/utils/breadcrumb-helpers"

export default function TreasuryIndexPage() {
  return (
    <PageContainer>
      <MetaData title="Treasury" />
      <PageTitle
        title="Treasury"
        subTitle="Assets backing the Scale project"
        items={[
          createBreadcrumbItem("more", "More", "/"),
          createBreadcrumbItem("treasury", "Treasury", "/treasury", true),
        ]}
      />
      <TreasuryComposite />
    </PageContainer>
  )
}
